import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../api';
import logger from '../../../utils/logger';
import { getImageUrl } from '../../../utils/urlHelper';
import './MutualStrip.css';

const nameOf = (u) => u?.username || u?.viewerProfile?.username || u?.userProfile?.username;
const profileOf = (u) => u?.userProfile || u?.viewerProfile || {};
const initials = (u) => {
  const p = profileOf(u);
  const f = p.firstName?.[0] || '';
  const l = p.lastName?.[0] || '';
  return (f + l).toUpperCase() || (nameOf(u) || '?').slice(0, 2).toUpperCase();
};
const displayName = (u) => {
  const p = profileOf(u);
  return p.firstName ? `${p.firstName} ${(p.lastName || '')[0] || ''}`.trim() : nameOf(u);
};

const avatarUrl = (u) => {
  const p = profileOf(u);
  const img = p.imageVisibility?.profilePic || p.profileImage ||
    (Array.isArray(p.images) && p.images[0]) ||
    (Array.isArray(p.publicImages) && p.publicImages[0]) || null;
  return img ? getImageUrl(img, { size: 'thumb' }) : null;
};

const ageOf = (u) => {
  const p = profileOf(u);
  if (p.age) return p.age;
  if (p.birthYear) {
    const yr = parseInt(p.birthYear, 10);
    if (yr > 1900) return new Date().getFullYear() - yr;
  }
  return null;
};

const MutualStrip = ({ username }) => {
  const navigate = useNavigate();
  const [mutuals, setMutuals] = useState(null);

  useEffect(() => {
    if (!username) return undefined;
    let alive = true;
    Promise.all([
      api.get(`/their-favorites/${encodeURIComponent(username)}`).catch(() => ({ data: {} })),
      api.get(`/favorites/${encodeURIComponent(username)}`).catch(() => ({ data: {} })),
    ]).then(([theirRes, myRes]) => {
      if (!alive) return;
      const theirs = theirRes.data?.users || [];
      const mine = new Set((myRes.data?.favorites || myRes.data?.users || []).map(nameOf).filter(Boolean));
      setMutuals(theirs.filter(u => mine.has(nameOf(u))).slice(0, 6));
    }).catch((err) => logger.error('Mutual strip load failed:', err));
    return () => { alive = false; };
  }, [username]);

  if (!mutuals || mutuals.length === 0) return null;

  return (
    <div className="dv2-mutual-strip">
      <h3 className="dv2-mutual-title">💞 Mutual — ready to talk</h3>
      <div className="dv2-mutual-row">
        {mutuals.map((u) => {
          const uname = nameOf(u);
          return (
            <div key={uname} className="dv2-mutual-card">
              <div className="dv2-mutual-photo">
                {avatarUrl(u)
                  ? <img className="dv2-mutual-photo-img" src={avatarUrl(u)} alt={displayName(u)} loading="lazy" />
                  : <div className="dv2-mutual-photo-init">{initials(u)}</div>}
                <span className="dv2-mutual-heart">💞</span>
                <div className="dv2-mutual-overlay">
                  <span className="dv2-mutual-name">{displayName(u)}</span>
                  {ageOf(u) && <span className="dv2-mutual-age">{ageOf(u)}</span>}
                </div>
              </div>
              <button type="button" className="dv2-mutual-hi" onClick={() => navigate('/messages')}>Hi 👋</button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MutualStrip;
